module.exports = __webpack_public_path__ + "img/paper_negative.6537aaf9.svg";